import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HeroSection from "../components/HeroSection";
import StartIn2Minutes from "../components/Quiz";
import WhatYouGet from "../components/What";
import HowItWorks from "../components/HowItWorks";
import FAQSection from "../components/FAQ";
import FooterPage from "../components/Footer";
export default function HomePage() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && (lang === "en" || lang === "de") && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 }
    );
    const elements = document.querySelectorAll(
      ".animate-on-scroll, .img-animate-on-scroll"
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <HeroSection />
      <StartIn2Minutes />
      <WhatYouGet />
      <HowItWorks />
      <FAQSection />
      <FooterPage />
    </>
  );
}
